export default function UIModalLayout({ children }) {
    return (
        <div className={`fixed flex w-screen top-0 duration-700 h-screen transition-all items-center justify-center z-[99999]`}>
            {children}
        </div>
    )
}
